import React, { useState } from "react";
import { Button } from "../design/button";
import {
  Dialog,
  DialogActions,
  DialogBody,
  DialogTitle,
} from "../design/dialog";
import { Field, Fieldset, FieldGroup, Label } from "../design/fieldset";
import { Textarea } from "../design/textarea";
import { Professional } from "../models/Professional";
import { useProfessional } from "../contexts/ProfessionalContext";

interface Props {
  professional: Professional;
  className?: string;
  children?: React.ReactNode;
}

const InviteProfessionalButton: React.FC<Props> = ({
  className,
  children,
  professional,
}) => {
  const { createInvitation } = useProfessional();
  const [isOpen, setIsOpen] = useState(false);
  const [message, setMessage] = useState<string>("");
  const [isSending, setIsSending] = useState(false);

  const handleSubmit = async () => {
    setIsSending(true);

    try {
      await createInvitation(professional._id, {
        message,
      });
      clearForm();
    } catch (error) {
      console.error("Error creating invite:", error);
      alert("Failed to create invite. Please try again later.");
    }

    setIsSending(false);
  };

  const clearForm = () => {
    setMessage("");
    setIsOpen(false);
  };

  return (
    <>
      <Button
        className={className}
        onClick={() => setIsOpen(true)}
      >
        {children}
      </Button>
      <Dialog open={isOpen} onClose={setIsOpen}>
        <DialogTitle>Invite {professional.name}</DialogTitle>
        <DialogBody>
          <Fieldset>
            <FieldGroup>
              <Field>
                <Label>Message</Label>
                <Textarea
                  rows={10}
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                  placeholder="Message"
                />
              </Field>
            </FieldGroup>
          </Fieldset>
        </DialogBody>
        <DialogActions>
          <Button plain onClick={clearForm}>
            Cancel
          </Button>
          <Button
            color="green"
            disabled={!message || isSending}
            onClick={handleSubmit}
          >
            {isSending ? "Sending..." : "Send"}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default InviteProfessionalButton;
